import React, { useState } from "react";

import { Tooltip } from "antd";
import Icon from "@ant-design/icons";
import "./AdnEmailLanguagePicker.css";

// Fluency Icons
import { ReactComponent as fluencyPT } from "../../../assets/images/image_languages/icons8-portugal-48.svg";
import { ReactComponent as fluencyEN } from "../../../assets/images/image_languages/icons8-great-britain-48.svg";

function AdnEmailLanguagePicker({ isEmailEnglishLanguages, setisEmailEnglishLanguages, disabled }) {
  return (
    <div className="profileFluency">
      <Tooltip title="English">
        <Icon
          style={{ fontSize: "2rem" }}
          component={fluencyEN}
          onClick={() => {
            if (!isEmailEnglishLanguages.en) {
              setisEmailEnglishLanguages((prev) => ({
                ...prev,
                en: !prev.en,
                pt: !prev.pt,
              }));
            }
          }}
          className={
            !isEmailEnglishLanguages.en
              ? "profileFluencyCheck hoveredIcon"
              : "hoveredIcon"
          }
        />
      </Tooltip>
      <Tooltip title="Portuguese">
        <Icon
          style={{ fontSize: "2rem" }}
          component={fluencyPT}
          onClick={() => {
            if (!isEmailEnglishLanguages.pt) {
              setisEmailEnglishLanguages((prev) => ({
                ...prev,
                pt: !prev.pt,
                en: !prev.en,
              }));
            }
          }}
          className={
            !isEmailEnglishLanguages.pt
              ? "profileFluencyCheck hoveredIcon"
              : "hoveredIcon"
          }
        />
      </Tooltip>
    </div>
  );
}

export default AdnEmailLanguagePicker;
